import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ServicesListComponent } from '../services-list/services-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { EnvironmentListComponent } from '../../environment-data/environment-list/environment-list.component';

@Component({
  standalone: true,
  selector: 'app-service-configuration',
  templateUrl: './service-configuration.component.html',
  styleUrls: ['./service-configuration.component.scss'],
  imports: [CommonModule, ServicesListComponent, MatTabsModule, PageHeaderComponent, EnvironmentListComponent]
})
export class ServiceConfigurationComponent {
  items: MenuItem[] = [];
  pageTitle: string = "Configure Services and Environments";
  pageSubTitle: string = "Configure and manage Services and Environments";
  totalRecords: number = 2;

  constructor() {
  }
  ngOnInit(): void {
  }
}
